<template>
  <div id="st-content-graphic" class="st-content-graphic scroll-content" :style="scrollContentStyle" itemscope itemtype="http://schema.org/NewsArticle">
    <meta itemprop="datePublished" v-if="date" :content="date" />
    <st-menu></st-menu>
    <!-- route outlet -->
    <!-- component matched by the route will render here -->
    <transition>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
    <st-footer ref="footer" v-if="!$inSTApp"></st-footer>
    <transition name="fade">
      <st-loading v-if="$loading.isLoading" />
    </transition>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import StMenu from './menu/index.vue'
import StFooter from './footer/index.vue'
import StLoading from './StLoading.vue'

export default {
  components: {StMenu, StFooter, StLoading},
  data () {
    return {
      scrollContentStyle: {
        'padding-bottom': 0
      }
    }
  },
  computed: mapState(['date']),
  methods: {
    handleResize () {
      this.scrollContentStyle['padding-bottom'] = this.$refs.footer.$el.getBoundingClientRect().height + 'px'
    }
  },
  mounted () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
  }
}
</script>

<style lang="scss">
.fade-leave-active {
  transition: opacity 1s;
}

.fade-leave-to {
  opacity: 0;
}
</style>
